import { render, staticRenderFns } from "./AddComment.vue?vue&type=template&id=1c6b0648&scoped=true"
import script from "./AddComment.vue?vue&type=script&lang=js"
export * from "./AddComment.vue?vue&type=script&lang=js"
import style0 from "./AddComment.vue?vue&type=style&index=0&id=1c6b0648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6b0648",
  null
  
)

export default component.exports